// extracted by mini-css-extract-plugin
export default {"buyPop":"congratsPop_buyPop__EIAfU","price":"congratsPop_price__0FW6v"};